import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
    objectWithoutProperties,
    extendClass
} from '../../../utils/utils';
import {
    toggleClasses,
    sidebarCssClasses,
    checkBreakpoint,
    validBreakpoints
} from './shared/index';


//================ Property Value Type =====================
var propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    display: PropTypes.any,
    mobile: PropTypes.bool,
    tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    type: PropTypes.string
};

//================ Default Property Value =====================
var defaultProps = {
    display: 'lg',
    mobile: false,
    tag: 'button',
    type: 'button'
};


const AppSidebarToggler=(props)=>{
    function sidebarToggle(e, force) {
        e.preventDefault();

        let display = props.display,
            mobile = props.mobile,
            cssClass = sidebarCssClasses[0];

        if (!mobile && display && checkBreakpoint(display, validBreakpoints)) {
            cssClass = 'sidebar-' + display + '-show';
        }
        toggleClasses(cssClass, sidebarCssClasses, force);
    };


    const  _props = props,
            className = _props.className,
            children = _props.children,
            Tag = _props.tag,
            attributes = objectWithoutProperties(_props, 'className', 'children', 'tag'),
            classes = classNames(className, 'navbar-toggler');

        delete attributes.mobile;
        delete attributes.display;

        return React.createElement(
            Tag,
            extendClass({ type: 'button', className: classes }, attributes, {
                onClick: (event) => {
                    return sidebarToggle(event);
                }, 'data-sidebar-toggler': true
            }),
            children || React.createElement('span', { className: 'fas fa-exchange-alt fa-lg' })
        );
}




export default AppSidebarToggler

//=================== Binding Value Type & Default Value ======================
AppSidebarToggler.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
AppSidebarToggler.defaultProps = defaultProps;